export default "__VITE_ASSET__ByurdYBo__"